import { render, staticRenderFns } from "./Setor.vue?vue&type=template&id=6d86a4ac&scoped=true&"
import script from "./Setor.vue?vue&type=script&lang=js&"
export * from "./Setor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86a4ac",
  null
  
)

export default component.exports